var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83334 7.3335H5.83334M7.16667 10.0002H5.83334M11.1667 4.66683H5.83334M13.8333 7.00016V4.5335C13.8333 3.41339 13.8333 2.85334 13.6154 2.42552C13.4236 2.04919 13.1176 1.74323 12.7413 1.55148C12.3135 1.3335 11.7534 1.3335 10.6333 1.3335H6.36667C5.24657 1.3335 4.68651 1.3335 4.25869 1.55148C3.88237 1.74323 3.57641 2.04919 3.38466 2.42552C3.16667 2.85334 3.16667 3.41339 3.16667 4.5335V11.4668C3.16667 12.5869 3.16667 13.147 3.38466 13.5748C3.57641 13.9511 3.88237 14.2571 4.25869 14.4488C4.68651 14.6668 5.24657 14.6668 6.36667 14.6668H8.16667M15.1667 14.6668L14.1667 13.6668M14.8333 12.0002C14.8333 13.2888 13.7887 14.3335 12.5 14.3335C11.2113 14.3335 10.1667 13.2888 10.1667 12.0002C10.1667 10.7115 11.2113 9.66683 12.5 9.66683C13.7887 9.66683 14.8333 10.7115 14.8333 12.0002Z",
    stroke: "#2EC99E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSearch);
export default __webpack_public_path__ + "static/media/file-search.bd501dbb58fded33c626719dcd9855b7.svg";
export { ForwardRef as ReactComponent };